export type PlatformApplicationStatus =
  | 'ACTIVE'
  | 'DELETING'
  | 'ERROR'
  | 'PROVISIONING';

export const ALL_PLATFORMS = ['APNS', 'APNS_SANDBOX', 'GCM'] as const;

export type PlatformType = typeof ALL_PLATFORMS[number];

export interface PlatformApplication {
  organization_id: string;
  messenger_id: string;
  platform: PlatformType;
  id: string;
  created_at: string;
  updated_at: string;
  platformApplicationArn: string | null;
  status: PlatformApplicationStatus;
  error_metadata: string | null;
}
